export const GET_WISHLISTS = "GET_WISHLISTS";
export const SET_WISHLIST_LENGTH = "SET_WISHLIST_LENGTH";
export const SET_WISHLIST_PAGINATION = "SET_WISHLIST_PAGINATION";
export const EMPTY_WISHLIST_CART = "EMPTY_WISHLIST_CART";
export const SELECTED_SIZE = "selectedSize";
